import { Component } from '@angular/core';

@Component({
  selector: 'page-maintenance',
  templateUrl: './page-maintenance.component.html',
  styleUrls: ['./page-maintenance.component.scss']
})
export class PageMaintenanceComponent {}
